import React, { useState } from "react";
import { BsPen, BsTrash } from "react-icons/bs";
import { useGlobalContext } from "context/globalContext";
import toast from "react-hot-toast";
import DeleteModal from "components/DeleteModal/DeleteModal";
import { deleteActivitiesAPI } from "Api/activitiesAPI";
import { consoleLog } from "helpers";

const EditAndDeleteActivities = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const {
    setActivitiesFormData,
    initialActivitiesFormState,
    setFetchActivities,
    setIsOpenActivitiesEditForm,
  } = useGlobalContext();
  // const [isSubmitting, setIsSubmitting] = useState(false);
  const handleDeleteClick = () => {
    setIsModalOpen(true);
  };

  const handleDeleteConfirm = async () => {
    const token = localStorage.getItem("jwtToken");
    const response = await deleteActivitiesAPI(
      { id: props.cell.row.original.id },
      () => {},
      token
    );
    if (response) {
      toast.success(`Activities deleted successfully`);
      consoleLog(["Delete successful:", response.data]);
      setFetchActivities(true);
    }
    if (!response) {
      toast.error("Activity deletion failed");
    }
    setIsModalOpen(false);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleFormOpen = () => {
    setActivitiesFormData(
      props.cell?.row?.original
        ? {
            ...props.cell.row.original,
          }
        : {
            ...initialActivitiesFormState,
          }
    );
    setIsOpenActivitiesEditForm(true);
    consoleLog([props, "props"]);
  };

  return (
    <div className="flex gap-4">
      <BsPen
        className="cursor-pointer fill-amber-900 w-5 h-5"
        onClick={handleFormOpen}
      />
      <BsTrash
        className="cursor-pointer fill-amber-900 w-5 h-5"
        onClick={handleDeleteClick}
      />
      <DeleteModal
        isOpen={isModalOpen}
        onRequestClose={handleCloseModal}
        onDelete={handleDeleteConfirm}
      />
    </div>
  );
};

export default EditAndDeleteActivities;
